module.exports = __webpack_public_path__ + "5b15e850ba80061f0e6bc36017dbaaf7.svg";